import '@common/preview/preview.shared';
import { fn } from '@common/utils';
import { IDocLink } from '@common/preview/preview.d';
import { IUndockedPreviewProxy, RWFDocViewer } from '@common/preview/preview.shared';
import { constants as kconstants, Bind } from './navkendo';
import { NavKendoRegister } from '@common/navkendo';
import { NavDock, INavDockSetting, INavDockLayoutSetting, INavDockedSettings } from './navkendo/navdock';
import { GetWindowOpenBounds } from '@common/infoma.environment';
import * as angular from 'angular';
import { ExternalPreview } from '@common/preview/externalpreview';
import { IRwfBootstrapParameters, ResolvePreviewSettings } from '@common/rwf';
import { IPreviewSettings } from '@common/interfaces';


export const EV_ExternalPreviewStateChangedError = "NavDockStateChangedError";
export const EV_ExternalPreviewStateChanged = "NavDockStateChanged";

export class RWFPreviewDock extends NavDock {
    public readonly UndockedPreview: ExternalPreview;

    constructor(element: any, options: INavDockSetting) {
        super(element, options);

        // document.documentElement: element might not yet be attached to document ... WTF
        const $injector = angular.element(element).injector() || angular.element(document.documentElement).injector();
        const $c = $injector && $injector.get("CompatibilityService");
        const UndockedPreview = this.UndockedPreview = new ExternalPreview(
            $c && ResolvePreviewSettings($c.resolve("Rwf")("RwfBootstrap").EnsureResolved()),
            $c && $c.resolve("InfomaAppVersion"));

        // Dispatch Incoming Save Annotations event (do we need more/all ?)
        this.one(kconstants.NavDestroy, 
            Bind(UndockedPreview, () => $(document).trigger("RWFAnnotationsSaved"), "RWFAnnotationsSaved"));            
        this.one(kconstants.NavDestroy, 
               Bind(UndockedPreview, () => $(document).trigger("InfStartSaveAnnotations"), "InfStartSaveAnnotations"));

        this.one(kconstants.NavDestroy, 
                Bind(UndockedPreview,  (s) => { 
                    var e = { Result: undefined }; 
                    $(document).trigger("CustomTextSelectionQuery", e); 
                    UndockedPreview.getUndocked()?.SetCustomTextSelectionState(e.Result);
                }, "CustomTextSelectionQuery"))

                this.one(kconstants.NavDestroy, 
                    Bind(UndockedPreview,  (s) => $(document).trigger("CustomTextSelection", s), "CustomTextSelection"))
                    
        if ($c) {
            const $RwfBootstrap = $c.resolve("Rwf")("RwfBootstrap");
            $RwfBootstrap.OnResolved((p: IRwfBootstrapParameters) => this.PreviewSettings = ResolvePreviewSettings(p), true);
        }

        this.one(kconstants.NavDestroy, Bind(UndockedPreview, () => {
            if (this.IsCollapsed()) {
                this.Expand(false);
                this.SetDocument(this.CurrentDoc);
            }
        }, ExternalPreview.EVENT_CLOSE));

        const layout = this.options && this.options.Layout;
        if (layout) {
            this.one(kconstants.NavDestroy, Bind(UndockedPreview, (e: INavDockedSettings) => {
                const dock = layout.DockedOptions || (layout.DockedOptions = new INavDockedSettings());
                dock.Offset = e.Offset;
                dock.Size = e.Size;
            }, ExternalPreview.EVENT_BOUNDSCHANGED));
        }

        // As gets Queried with this name  ....
        this.element.data("kendoNavDock", this);
        this.one(kconstants.NavDestroy, () => {
            this.element.removeData("kendoNavDock");

            this.ifUndocked((proxy, UndockedPreview) => {
                //proxy.SetCurrentDoc(undefined);
                proxy.Close(UndockedPreview.CurrNo);
            });

            if (this.docViewer)
                this.docViewer.destroy();
        });

        // ensure Close of Undocked preview if gets UnCollapsed
        this.bind(kconstants.ExpansionStateChanged, () => {
            if (!this.IsCollapsed()) {
                UndockedPreview.IsActive = false;
                this.SetDocument(this.currentLink);
            }
        });
        const ev_id = '.navDockAnno_' + fn.id();
        var annoInfo: JQuery;
        $(document.documentElement).on('InfStartSaveAnnotations' + ev_id + ' InfEndSaveAnnotations' + ev_id + ' InfStartLoadDocument' + ev_id + ' InfEndLoadDocument' + ev_id, (e) => {
            annoInfo = annoInfo || (annoInfo = $('<div class="idms_DockTitleInfo" title="ddd"><img src="./loading.gif" ng-show="IsInRefresh" style="margin: -3px 0px 0px 16px; vertical-align: middle;"></div></div>').insertAfter(this.titleInfo));
            const isLoad = (e.type || '').substr(0, 8) === 'InfStart';
            annoInfo.toggle(isLoad);
            if (isLoad)
                annoInfo.attr('title', e.type === 'InfStartSaveAnnotations' ? 'Annotationen werden gespeichert' : 'Dokument laden ...');
        });
        this.one(kconstants.NavDestroy, () => $(document.documentElement).off(ev_id));

        var lastPreviewToken;
        this.bind('DockMoved', () => {
            var CurrentDoc = this.CurrentDoc;
            var currRefreshToken = lastPreviewToken = new Object();
            if (CurrentDoc) {
                window.setTimeout(() => {
                    if (!this.ifUndocked(() => { }) && lastPreviewToken == currRefreshToken && this.CurrentDoc === CurrentDoc) {

                        var obj = this.ContentContainer.find("object");
                        var objContainer = obj.parent();
                        if (obj.length > 0 && objContainer.length > 0) {
                            var pdfContent = objContainer.html();
                            objContainer.remove("object");
                            // Reattach PDF preview
                            objContainer.html(pdfContent);
                        } else if(this.docViewer?.element)
                            $(this.docViewer.element).remove()
                            this.docViewer.destroy();
                            delete this.docViewer;
                            this.SetDocument(this.CurrentDoc);                    
                    }
                });
            }
        });
    }

    /** Dock the dock from a separate browser popup window */
    public DockWindow() {
        // Dock undocked window
        if (this.IsCollapsed()) {
            this.Expand(true);
        }

        if (this.UndockedPreview) {
            this.UndockedPreview.EnsureClosed();
        }
    }

    public UndockWindow() {

        const undockPopup = this.UndockedPreview;

        let dockZone = this.element.parent();
        let layout = this.options && this.options.Layout;
        if (layout && !layout.DockedOptions) {
            dOpt = layout.DockedOptions = new INavDockedSettings();
            dOpt.Offset = dockZone.position();
            // Calculate relative to current dock Position
            if (window.event) {
                const screenX = (<JQueryEventObject>window.event).screenX;
                if (screenX > 0) {
                    dOpt.Offset.top += screenX;
                    dOpt.Offset.left += 15;
                }
            }
        }
        var dOpt = layout && layout.DockedOptions;

        let offset = dOpt.Offset;
        let size = (dOpt && dOpt.Size) || { height: 500, width: 700 };

        size.width = Math.max(dockZone.innerWidth() - 60, 100); // Minimum required width is 100px by specs
        size.height = Math.max(dockZone[0].scrollHeight - 80, 100); // Minimum required height is 100px by specs
        // Get browser dependent window.open() parameter window bounds
        let windowBounds = GetWindowOpenBounds({ x: offset.left, y: offset.top, width: size.width, height: size.height });

        undockPopup.IsActive = true;
        undockPopup.EnsureAlive(windowBounds).then(alive => {
            // Undock dock
            if (!this.IsCollapsed())
                this.Collapse();

            this.SetDocument(this.CurrentDoc);
            this.getDocViewer().SetFallbackContent("Das Dokument wird aktuell nur im abgedockten Fenster angezeigt. Wenn Sie das Dokument in diesem Fenster sehen möchten, schließen Sie das abgedockte Fenster!");

            WithScope(this, s => s.$emit(EV_ExternalPreviewStateChanged, this));
        }, err => {
            this.Expand(false);
            WithScope(this, s => s.$emit(EV_ExternalPreviewStateChangedError, this));
        });
        if (undockPopup.Alive) {
            var undock = <IUndockedPreviewProxy>undockPopup.getUndocked();
            if (this.CurrentDoc && undock) {
                undock.SetCurrentDoc(this.CurrentDoc);
            }
        }
    }

    private PreviewSettings?: IPreviewSettings;
    /** Get preview Content to Display in preview */
    public get CurrentDoc(): IDocLink {
        return this.currentLink;
    }

    private currentLink: IDocLink;

    /** Execute Action if Currently Undocked, otherwise return false */
    private ifUndocked(action: (proxy: IUndockedPreviewProxy, externalPreview: ExternalPreview) => void) {
        const UndockedPreview = this.UndockedPreview;
        if (!UndockedPreview.IsActive) {
            return false;
        } else {
            fn.UISafe(UndockedPreview.EnsureAlive().then((p: IUndockedPreviewProxy) => {
                if (p.Alive) {
                    action(p, UndockedPreview);
                } else {
                    UndockedPreview.IsActive = false;
                }
            }).then(fn.noop, err => {
                this.Expand(false);
                const event = WithScope(this, s => s.$emit(EV_ExternalPreviewStateChangedError, this));

                if (!event || !event.defaultPrevented) {
                    throw err;
                }
            }));
            return true;
        }
    }

    private getDocViewer(impCreate: boolean = true) {
        return this.docViewer || (impCreate ? (this.docViewer = this.createViewer()) : undefined);
    }
    private createViewer() {
        var result = new RWFDocViewer($("<div></div>"), this.PreviewSettings);
        result.element.height("100%");
        result.element.appendTo(this.ContentContainer);
        return result;
    }
    private docViewer: RWFDocViewer;

    public SetDocument(docLink: IDocLink) {
        this.currentLink = docLink;
        if (!this.IsCollapsed() || !this.ifUndocked(proxy => proxy.SetCurrentDoc(docLink))) {
            // Set Link Only on not Collapsed State
            if (this.ContentContainer.is(":visible")) {
                this.getDocViewer().SetDocLink(docLink);
            }
        }

        this.SetTitle("Vorschau: " + (docLink ? docLink.Title || "Hauptdokument" : 'Keine Dokumente vorhanden'));
    }

    public ApplySettings(settings: INavDockLayoutSetting, setResizable: boolean = true) {
        var dOpt = settings && settings.DockedOptions;
        if (dOpt) {
            const UndockedPreview = this.UndockedPreview;
            UndockedPreview.IsActive = !dOpt.IsDocked;
            if (UndockedPreview.IsActive) {
                UndockedPreview.EnsureAlive({
                    x: dOpt.Offset && dOpt.Offset.left,
                    y: dOpt.Offset && dOpt.Offset.top,
                    height: dOpt.Size && dOpt.Size.height,
                    width: dOpt.Size && dOpt.Size.width,
                });
            }
        }
        super.ApplySettings(settings, setResizable);
    }

    /** Get the current (not saved) settings of this dock */
    public GetSettings() {
        var result = super.GetSettings();
        const dOpt = result.DockedOptions = new INavDockedSettings();
        dOpt.IsDocked = !this.UndockedPreview.IsActive;
        var un = this.UndockedPreview.getUndocked();
        let wBounds = un && un.WindowBounds;
        if (wBounds) {
            // lives in other window
            this.UndockedPreview.UpdateUndockPosition(wBounds);
            dOpt.Offset = { left: wBounds.WindowX, top: wBounds.WindowY };
            dOpt.Size = { height: wBounds.ContentHeight, width: wBounds.ContentWidth };
        }
        return result;
    }

}
NavKendoRegister(RWFPreviewDock, "RwfPreviewDock");

/** Execute On Scope Attached to Widget */
function WithScope<T>(widget: kendo.ui.Widget, scopeAction: (this: kendo.ui.Widget, scope: ng.IScope) => T) {
    var scope = widget && widget["$angular_scope"];
    if (scope) {
        return scopeAction.bind(widget, scope)() as T;
    }
}
